import React, { useContext } from "react";
import { themeContextType, ThemeMode } from "./types";

export const ThemeContext = React.createContext<themeContextType | null>(null);

export function useThemeContext(): themeContextType {
  const theme = useContext(ThemeContext);
  if (theme) return theme;
  const fallbackMode: ThemeMode = "light";
  return { mode: fallbackMode, setMode: () => {} };
}
